export default __webpack_public_path__ + "static/media/header-partners.65cbcaaf.png";